// src/App.js
import React, { useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import InviteRegistrationPage from "./pages/InviteRegistrationPage/InviteRegistrationPage";
import LoginPage from "./pages/LoginPage/LoginPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage/ForgotPasswordPage";
import MainApp from "./MainApp.tsx";
import PrivateRoute from "./PrivateRoute";
import { ThemeProvider } from "styled-components";
import {
  ThemeProvider as MuiThemeProvider,
  CssBaseline,
  Switch,
} from "@mui/material";
import { darkTheme, lightTheme, colorPrimitives } from "./theme";
import { resolveColors } from "./utils/material";

function App() {
  const [isDarkMode, setIsDarkMode] = useState(false);
  const toggleTheme = () => setIsDarkMode(!isDarkMode);

  const theme = isDarkMode ? darkTheme : lightTheme;
  const resolvedTheme = resolveColors(theme, colorPrimitives);

  return (
    <MuiThemeProvider theme={resolvedTheme}>
      <ThemeProvider theme={resolvedTheme}>
        <CssBaseline />

        <div style={{ height: 30, padding: 0 }}>
          <label>
            {isDarkMode ? "Dark" : "Light"} theme
            <Switch checked={isDarkMode} onChange={toggleTheme} />
          </label>
        </div>

        <Routes>
          {/* Публичные маршруты */}
          <Route path="/user/register-by-invitation/:tokenId" element={<InviteRegistrationPage />} />
          <Route path="/user/login" element={<LoginPage />} />
          <Route path="/user/forgot-password" element={<ForgotPasswordPage />} />

          {/* Если пользователь заходит на корень, перенаправляем на страницу логина */}
          <Route path="/" element={<Navigate to="/user/login" replace />} />

          {/* Защищённый блок, где путь содержит enterpriseId */}
          <Route
            path="/:enterpriseId/*"
            element={
              <PrivateRoute>
                <MainApp />
              </PrivateRoute>
            }
          />
        </Routes>
      </ThemeProvider>
    </MuiThemeProvider>
  );
}

export default App;
